// 自动曝光点击打点的div
import { useEffect, useRef, useCallback } from 'react';
import { sendPoint } from '@/util/common';
import PropTypes from 'prop-types';

const LogDiv = (props) => {
  const { impr, click, imprProps = {}, clickProps = {}, className, onClick, style, id } = props;
  const imprRef = useRef(null);
  const observerRef = useRef(null);

  const handleIntersection = useCallback(
    (entries) => {
      entries.forEach((entry) => {
        // 检查元素是否在视口中且是首次进入
        if (entry.isIntersecting && !entry.target.hasBeenIntersected) {
          sendPoint({ event_name: impr, ...imprProps });

          // 标记元素已经曝光过，以避免再次触发
          entry.target.hasBeenIntersected = true;

          // 如果不再需要观察该元素，可以取消观察
          observerRef.current.unobserve(entry.target);
        }
      });
    },
    [impr, imprProps]
  );

  useEffect(() => {
    if (impr) {
      observerRef.current = new IntersectionObserver(handleIntersection, {
        root: null, // 使用浏览器视口作为根元素
        rootMargin: '0px', // 根元素的外边距
        threshold: 0.1, // 目标元素与视口相交的比例（0-1），这里是 10%
      });
      observerRef.current.observe(imprRef.current);
    }
    return () => {
      observerRef.current && imprRef.current && observerRef.current.unobserve(imprRef.current);
    };
  }, [impr, handleIntersection]);

  const handleClick = (e) => {
    if (click) sendPoint({ event_name: click, ...clickProps });
    onClick && onClick(e);
  };

  return (
    <div onClick={handleClick} ref={imprRef} className={className} style={style} id={id}>
      {props.children}
    </div>
  );
};

LogDiv.propTypes = {
  impr: PropTypes.string,
  click: PropTypes.string,
  imprProps: PropTypes.object,
  clickProps: PropTypes.object,
  className: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
  children: PropTypes.any,
  id: PropTypes.string,
};

export default LogDiv;
